import { Injectable, TemplateRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Observable } from 'rxjs';
import { AppService } from '../app.service';
import { Referent } from '../models/referent';
import { Rucher } from '../models/rucher';
import { Ruche } from '../models/ruche';
import { Actu } from '../models/actu';
import { VilleMateriel } from '../models/villeMateriel';
import { Materiel } from '../models/materiel';

@Injectable()
export class AdminService {
    public writeReferentModal: TemplateRef<any>;
    public writeRucherModal: TemplateRef<any>;
    public writeRucheModal: TemplateRef<any>;
    public writeActuModal: TemplateRef<any>;
    public writeMaterielModal: TemplateRef<any>;
    public referents: Referent[];
    public villesMatos: VilleMateriel[];
    private data;
    private placesPossibles = ['1', '2' ,'3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'];

    constructor(private http: HttpClient, private appService: AppService) {}

    private url = './rest/restapi.php?rquest=';
    // private url = './sagerucher-server/rest/restapi.php?rquest=';
//  private url = 'http://localhost:4444/sagerucher-server/rest/restapi.php?rquest=';

    
    /*********************************************************************/
    /**************************** REFERENTS ******************************/
    /*********************************************************************/
    getReferents(): Observable<Referent[]> {
        this.data = this.http.get<Referent[]>(this.url + 'getReferents');
        return this.data;
    }

    getReferent(id: string): Referent {
        return this.referents.find(referent => referent.id_ref === id);
    }


    updateReferent(referent: Referent): Observable<Referent[]> {
        return this.http.post<Referent[]>(this.url + 'updateReferent', JSON.stringify(referent));
    }

    addReferent(referent: Referent): Observable<Referent[]> {
        return this.http.post<Referent[]>(this.url + 'addReferent', JSON.stringify(referent));
    }

    getListeRefsAvecDiscrimination(refsAEnlever: Referent[]): Referent[] {
        let refsDiscrimines = this.referents.slice(0);
        for (let refAEnlever of refsAEnlever) {
            refsDiscrimines.splice(refsDiscrimines.findIndex(referent=>referent.id_ref===refAEnlever.id_ref), 1);
        }
        return refsDiscrimines;
    }

    /*********************************************************************/
    /***************************** RUCHERS *******************************/
    /*********************************************************************/


    updateRucher(rucher: Rucher): Observable<Rucher[]> {
        return this.http.post<Rucher[]>(this.url + 'updateRucher', JSON.stringify(rucher));
    }

    addRucher(rucher: Rucher): Observable<Rucher[]> {
        return this.http.post<Rucher[]>(this.url + 'addRucher', JSON.stringify(rucher));
    }

    updateActu(actu: Actu): Observable<Actu> {
        return this.http.post<Actu>(this.url + 'updateActu', JSON.stringify(actu));
    }


    /*********************************************************************/
    /****************************** RUCHES *******************************/
    /*********************************************************************/
    getListeRuchesDisponibles(ruchesAvecRucher): Ruche[] {
        let ruchesDiscrimines = this.appService.ruches.slice(0);
        
        let ruchesAEnlever: Ruche[] = this.appService.ruches.filter(ruche => ruche.id_rucher);

        for (let rucheAEnlever of ruchesAEnlever) {
            ruchesDiscrimines.splice(ruchesDiscrimines.findIndex(ruche=>ruche.id_ruche===rucheAEnlever.id_ruche), 1);
        }

        return ruchesDiscrimines;
    }

    updateRuche(ruche: Ruche): Observable<Ruche[]> {
        return this.http.post<Ruche[]>(this.url + 'updateRuche', JSON.stringify(ruche));
    }

    addRuche(ruche: Ruche): Observable<Ruche[]> {
        return this.http.post<Ruche[]>(this.url + 'addRuche', JSON.stringify(ruche));
    }

    getListeEmplacementsSelectionnables(ruches: Ruche[]) {
        let emplacementsPossibles = this.placesPossibles.slice(0);

        for (let emplacementAEnlever of ruches) {
            emplacementsPossibles.splice(emplacementsPossibles.findIndex(emplacement=>emplacement===emplacementAEnlever.emplacement), 1);
        }

        return emplacementsPossibles;
    }

    /*********************************************************************/
    /****************************** MATOS ********************************/
    /*********************************************************************/
    getVillesMatos(): Observable<VilleMateriel[]> {
        this.data = this.http.get<VilleMateriel[]>(this.url + 'getVillesMatos');
        return this.data;
    }
    
    addVilleMatos(villeMatos: VilleMateriel): Observable<VilleMateriel[]> {
        return this.http.post<VilleMateriel[]>(this.url + 'addVilleMatos', JSON.stringify(villeMatos));
    }

    updateVilleMatos(villeMatos: VilleMateriel): Observable<VilleMateriel[]> {
        return this.http.post<VilleMateriel[]>(this.url + 'updateVilleMatos', JSON.stringify(villeMatos));
    }

    removeVilleMatos(idVilleMatos: object): Observable<VilleMateriel[]> {
        return this.http.post<VilleMateriel[]>(this.url + 'removeVilleMatos', JSON.stringify(idVilleMatos));
    }

    addMatos(matos: Materiel): Observable<Materiel[]> {
        return this.http.post<Materiel[]>(this.url + 'addMatos', JSON.stringify(matos));
    }

    updateMatos(matos: Materiel) {
        return this.http.post(this.url + 'updateMatos', JSON.stringify(matos));
    }

    removeMatos(matos: Materiel): Observable<Materiel[]> {
        return this.http.post<Materiel[]>(this.url + 'removeMatos', JSON.stringify(matos));
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.service.ts